module.exports = __webpack_public_path__ + "img/echo-viewpoint-3.22eb7229.jpg";